import { autoinject, computedFrom, observable } from 'aurelia-framework';
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";

@autoinject
export class ThingsNode extends TemperatureBaseDevice {

	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api, i18n);
	}

	activate(device: Device) {
		this.device = device;
	}

	attached() {
		if (this.tooltip) {
			//this.tooltip.position = "bottom";
			this.tooltip.html = this.buildToolTip();
		}

	}

	
}